import { Button } from '@eb/eds-button';
import { gettext } from '@eb/i18n';
import { trackAnalyticsEvent } from '@eb/site-analytics';
import { css, cx } from 'emotion';
import React from 'react';
import { Collection, GACodes } from '../../types';
import { CollectionCards } from '../_shared/CollectionCards';

export const LAYOUT_COLUMNS = 1;

export interface Props {
    collections: Collection[];
    count: number;
    viewMoreCollections: (isOpen: boolean) => void;
}

export const MoreRelatedCollections: React.FC<Props> = ({
    collections,
    count,
    viewMoreCollections,
}) => {
    const _handleButtonClick = () => {
        viewMoreCollections && viewMoreCollections(true);
        trackAnalyticsEvent({
            category: GACodes.GA_CATEGORY_CREATOR_COLLECTIONS_LISTING,
            action: GACodes.GA_ACTION_COLLECTIONS_MODAL_LINK_CLICK,
            label: GACodes.GA_LABEL_SHELF,
        });
    };

    return (
        <>
            <hr className="l-section eds-l-mar-top-2" />
            <div className="eds-g-group" data-testid="more-related-collections">
                <div className="eds-g-cell eds-g-cell--has-overflow eds-g-cell-12-12 eds-g-cell-mn-8-12 eds-g-offset-mn-2-12 eds-l-pad-top-10 eds-l-pad-hor-5">
                    <div className="eds-text--center eds-text-hs eds-l-mar-bot-8">
                        {gettext('More collections that feature this event')}
                    </div>
                    <div className={cx(styles.cardsContainer)}>
                        <CollectionCards
                            collections={collections}
                            columns={LAYOUT_COLUMNS}
                        />
                        {count > 3 && (
                            <div className="eds-l-mar-top-6 eds-align--center">
                                <Button
                                    style="link"
                                    onClick={_handleButtonClick}
                                >
                                    {gettext('View more collections')}
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

const styles = {
    cardsContainer: css`
        max-width: 660px;
        margin: auto;
        font-size: 16px;
    `,
};
